import Avatar from '@mui/material/Avatar';
import { cn } from 'cn';

import type { UUID } from '~/types/common';

import { getInitials } from '@vestigas/utils';

export type AvatarUser = {
  readonly email: string;
  readonly firstName?: string | null;
  readonly id: UUID;
  readonly lastName?: string | null;
};

export type UserAvatarSize = 'sm' | 'md';

const AVATAR_PALETTE = [
  'bg-rose-100 text-rose-700',
  'bg-orange-100 text-orange-700',
  'bg-amber-100 text-amber-700',
  'bg-lime-100 text-lime-700',
  'bg-emerald-100 text-emerald-700',
  'bg-teal-100 text-teal-700',
  'bg-sky-100 text-sky-700',
  'bg-indigo-100 text-indigo-700',
  'bg-violet-100 text-violet-700',
  'bg-pink-100 text-pink-700',
] as const;

const SIZE_CLASS_NAMES: Record<UserAvatarSize, string> = {
  md: 'size-8 text-sm',
  sm: 'size-6 text-xs',
};

/** The same user id always maps to the same palette entry. */
function getAvatarColor(userId: UUID) {
  let hash = 0;
  for (const character of userId) {
    hash += character.charCodeAt(0);
  }

  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length];
}

type UserAvatarProps = {
  readonly size?: UserAvatarSize;
  readonly user: AvatarUser;
} & ComponentStyling;

export function UserAvatar({
  className,
  size = 'md',
  style,
  user,
}: UserAvatarProps) {
  return (
    <Avatar
      className={cn(
        'font-bold',
        getAvatarColor(user.id),
        SIZE_CLASS_NAMES[size],
        className,
      )}
      style={style}
    >
      {getInitials(user)}
    </Avatar>
  );
}
